// ResponsiveRetourAchat.jsx → src/gestion-retour-achat/
import React from "react";
import GestionRetourAchat from "./GestionRetourAchat";
import RetoursAchatMobile from "../mobile/achats/RetoursAchatMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveRetourAchat(props) {
  return useIsMobile() ? <RetoursAchatMobile {...props} /> : <GestionRetourAchat {...props} />;
}
